import type { LoginError } from "@authentication/domain/errors/login/login.error";
import type { AuthenticationRepository } from "@authentication/domain/repositories/authentication.repository";
import { authenticationTypes } from "@authentication/root/authentication-types.di";
import { inject, injectable } from "inversify";
import type { ResultAsync } from "neverthrow";

@injectable()
export class AuthenticationLoginUseCase {
    constructor(
        @inject(authenticationTypes.repositories.AuthenticationRepository)
        private readonly authenticationRepository: AuthenticationRepository,
    ) {}

    execute(
        email: string,
        password: string,
        rememberSession = true,
    ): ResultAsync<true, LoginError> {
        return this.authenticationRepository.login(
            email,
            password,
            rememberSession,
        );
    }
}
